<template>
<m-pageframe
    title="Test Revoke Authentication"
>
<v-container>
    <h1>Revoke Authenticiation</h1>
    
    <p>
        Clicking the 'revoke authentication' button (below) will revoke all access tokens for this account.  
        This will have the effect of logging this account out on every device that is currently signed into the service.  
        You will be able to immediate log back in with your current (unchanged) password.
    </p>
    <p>
        <v-btn
            v-on:click="revokeAuth"
        >
            Revoke Authentication
        </v-btn>
    </p>
    
</v-container>
</m-pageframe>
</template>

<script>

export default {
    methods: {
        revokeAuth() {
            this.$rc.revokeAuth();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>